import "./components/home.js";
import "./components/main.js";
import "./components/scrolbhv.js";
import "./components/split.js";
